import { ComponentsOverrides } from '@mui/material/styles/overrides';
import { paperClasses as muiPaperClasses } from '@mui/material/Paper';
import { autocompleteClasses } from '.';
import { INPUT_BORDER_RADIUS } from '../theme/constants';

const styleOverrides: ComponentsOverrides['MuiAutocomplete'] = {
  input: {
    // artificially increase specificity - padding is normally set with .Mui_Input-root.MuiAutocomplete-input
    [`&.${autocompleteClasses.input}`]: {
      padding: 0,
      paddingTop: '2px',
    },
  },
  endAdornment: {
    top: 'auto',
  },
  popper: {
    [`& > .${muiPaperClasses.root}`]: {
      borderRadius: INPUT_BORDER_RADIUS,
    },
  },
};

export default styleOverrides;
